// src/components/PageTitle.js
import { useEffect } from "react";

export default function PageTitle({ title }) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null; // this component only sets the title
}
